import React, { useContext } from "react";
import { Button, Grid, Tooltip, makeStyles } from "@material-ui/core";
import { isMobile } from 'react-device-detect'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import { Check } from "@material-ui/icons";
import { useLocation, useHistory } from "react-router-dom"
import { useMemo } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiButton-endIcon": {
      display: "inherit",
      marginLeft: "8px",
      marginRight: "-4px",
      width: "35px",
    },
    "& .MuiButton-label": {
      justifyContent: "space-between",
    },
  },
}));

const BestPrice = () => {
  return (
    <div className="annaul-plan-container">
      <div className="best-price-line">VALUE</div>
      <div className="best-price-line">BEST</div>
    </div>
  );
};

export const CustomizePlanSelection = () => {
  const insurancePurchaseContext = useContext(InsurancePurchaseContextStore);
  const location = useLocation()
  const classes = useStyles();
  const history = useHistory();

  const isAnnual = () => {
    return location.pathname.endsWith("annual") || location.pathname.endsWith("fleet");
  }

  const isMonthly = () => {
    return location.pathname.endsWith("monthly");
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Tooltip title="Coverage will begin on selected date">
          <div className="choose-plan-title text-body bold black margin-bottom-small">
            Plan
          </div>
        </Tooltip>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item>
          <Button
            fullWidth={isMobile}
            onClick={() => {
              if(location.pathname.endsWith("fleet")) return;
              history.push('/insurance/annual')
            }}
            style={{ textTransform: "none" }}
            variant={isAnnual() ? "contained" : "outlined"}
            color="primary"
            startIcon={isAnnual() ? <Check /> : <div />}
            endIcon={<BestPrice />}
            disableElevation
            className={`${classes.root}${isAnnual() ? " annual-active" : " annual-inactive"}`}
          >
            Annual
          </Button>
        </Grid>
        <Grid item>
          <Button
            fullWidth={isMobile}
            onClick={() => history.push('/insurance/monthly')}
            style={{ textTransform: "none" }}
            variant={isMonthly() ? "contained" : "outlined"}
            color="primary"
            startIcon={isMonthly() ? <Check /> : <div />}
            disableElevation
            disabled={location.pathname.endsWith("fleet")}
          >
            Monthly
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
